import {Component, Input, OnInit} from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {Pagination} from "@core/bean/pagination";
import {NzModalService} from "ng-zorro-antd";
import {BrowseConfig} from "@core/bean/browse-config";
import {CommonsService} from "@core/service/commons.service";
import { PurOrderToAskGoodsService } from '@shared/components/browse/purOrderToAskGoods/purOrderToAskGoods.service';

@Component({
  selector: 'app-purOrderToAskGoods',
  templateUrl: './purOrderToAskGoods.html',
  styles: []
})
export class PurOrderToAskGoods implements OnInit {

  static componentName = 'PurOrderToAskGoodsBrowse';

  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;

  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  constructor(private commonsService:CommonsService,
              private modalService:NzModalService,
              private service:PurOrderToAskGoodsService
  ) {
    this.pagination.getData = function (params:HttpParams):Observable<any> {
      return service.query(params);
    }
  }

  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.searchData['materialName-askCounts'] = "askCounts";
    this.pagination.searchData['purOrder.status'] = "2";
    this.pagination.searchData['deleted-notEq'] = "1";
    this.pagination.searchData['purOrder.skipSupplier'] = "false";
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

}
